import type { I18nFn } from 'i18n/types/I18nFn';
import { colors } from 'theme/theme';

export function APPLICATION_STATUSES_ALL(i18n: I18nFn) {
  return {
    APPLIED:
      /* Status */
      i18n('Applied'),
    UNDER_CONSIDERATION:
      /* Status */
      i18n('Under Consideration'),
    INTERVIEWING:
      /* Status */
      i18n('Interviewing'),
    MADE_OFFER:
      /* Status */
      i18n('Made Offer'),
    HIRED:
      /* Status */
      i18n('Hired'),
    DISQUALIFIED:
      /* Status */
      i18n('Disqualified'),
  } as const satisfies Record<string, string>;
}

export type PagesToShowByApplicationStatus = Record<
  keyof ReturnType<typeof APPLICATION_STATUSES_ALL>,
  number
>;

export function APPLICATION_STATUSES_ALL_KEYS(i18n: I18nFn) {
  return Object.keys(APPLICATION_STATUSES_ALL(i18n)) as (keyof ReturnType<
    typeof APPLICATION_STATUSES_ALL
  >)[];
}

// before that date, referrers were not tracked, so we don't want to show wrong data
export const APPLICATION_REFERRER_SUPPORT_DATE = '2021-04-07T12:00:00.000Z';

const COLOR_MAP = {
  APPLIED: {
    bg: colors.skyBlue,
    color: 'white',
  },
  UNDER_CONSIDERATION: {
    bg: colors.brandBlue,
    color: 'white',
  },
  INTERVIEWING: {
    bg: colors.brightPlum,
    color: 'white',
  },
  MADE_OFFER: {
    bg: colors.brandYellow,
    color: colors.darkContentGrey,
  },
  HIRED: {
    bg: colors.brandGreen,
    color: 'white',
  },
  DISQUALIFIED: {
    bg: colors.elementGrey,
    color: colors.darkContentGrey,
  },
  // RSVP statuses
  GOING: {
    bg: colors.brandGreen,
    color: colors.white,
  },
  INTERESTED: {
    bg: colors.skyBlue,
    color: colors.white,
  },
  NOT_GOING: {
    bg: colors.elementGrey,
    color: colors.darkContentGrey,
  },
};

export const getColor = (key: keyof typeof COLOR_MAP) =>
  COLOR_MAP[key] || COLOR_MAP.APPLIED;

export function RSVP_STATUSES(i18n: I18nFn) {
  return {
    GOING: i18n('Attending'),
    INTERESTED: i18n('Interested'),
    NOT_GOING: i18n('Not Attending'),
  } as const;
}
